<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.requisicao"
            :tbody-tr-class="rowClass"
            class="table-requisicoes"
            ref="DataTable"
            sort-by="dataRequisicao"
            search-by="unidadeNomeFantasia"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="$router.push({ name: 'almoxarifado-requisicao-abertura-fechamento-edit', params: { id: item.id } })"
                    authorize="update-almoxarifado-requisicao-abertura-fechamento"
                    color="primary"
                    small
                    title="Visualizar"
                >
                    <rkm-icon icon="eye" />
                </rkm-button>

                <rkm-button
                    @click.stop="handleDestroy(item)"
                    :disabled="!!item.iniciouResposta"
                    authorize="destroy-almoxarifado-requisicao-abertura-fechamento"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>

            <template #afterTable>
                <div class="my-2">
                    <p>A linha em <span class="blue">azul</span> representa que a requisição teve uma nova resposta do almoxarifado para o qual foi requisitado.</p>
                </div>
            </template>
        </rkm-data-table>
    </div>
</template>

<script>
// Others.
import { repository, error } from '@/mixins'

export default {
    computed: {
        fields() {

            return [
                {
                    key: 'dataRequisicao',
                    name: 'requisicao.createdAt',
                    label: 'Data da requisição',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'unidadeNomeFantasia',
                    name: 'unidade.nomeFantasia',
                    label: 'Unidade',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'infraestruturaNome',
                    name: 'infraestrutura.nome',
                    label: 'Local de atendimento',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'setorNome',
                    name: 'setor.nome',
                    label: 'Setor (Almoxarifado)',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'usuarioRequisitante',
                    name: 'cidadao.nome',
                    label: 'Usuário requisitante',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'numero',
                    name: 'requisicao.numero',
                    label: 'Número',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'dataUltimoRecebimento',
                    label: 'Data do último recebimento',
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                },
            ]
        }
    },
    created() {

        this.repositories = {
            requisicao: this.getConectaSusRepository('almoxarifado.requisicaoAberturaFechamento')
        }
    },
    methods: {
        rowClass(item, type) {

            if (type === 'row' && item && item.possuiNovoEnvio) {

                return 'table-primary'
            }
        },
        handleDestroy({ id }) {

            const destroy = () => this.repositories.requisicao.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a requisição?', destroy, this.handleError)
        },
    },
    mixins: [repository, error],
    mounted() {

        this.$nextTick().then(() => this.$refs.DataTable.refresh())
    }
}
</script>

<style scoped>
.table-requisicoes >>> .blue { color: blue; }
</style>